<div class="account-section">
  <div class="my-section-box">
    <form [formGroup]="returnShippingform">
      <div class="my-section-box__headline">{{'dataExtractionRquest.returnShippingInformation'|cxTranslate}}
      </div>
      <div class="data-extraction__form">
        <div class="my-section-box-inner">
          <div class="my-section-box-inner">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <label class="label-title">{{'returnShippingInformation.return_shipping_type'|cxTranslate}}
                  <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info"
                    (click)="openReturnShippingInformationpopup()" />
                </label>

                <div class="square-radio-group">

                  <label class="square-radio">
                    <input type="radio" formControlName="returnShippingType" value="domestic" />
                    <span class="custom-square"></span>
                    {{'returnShippingInformation.domestic'|cxTranslate}}
                  </label>

                  <label class="square-radio">
                    <input type="radio" formControlName="returnShippingType" value="international" />
                    <span class="custom-square"></span>
                    {{'returnShippingInformation.international'|cxTranslate}}
                  </label>

                </div>
              </div>
            </div>

            <!--   <div class="row margin-top-25">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="carrier" class="control-label">{{'returnShippingInformation.carrier'|cxTranslate}}</label>
                <input class="form-control" formControlName="carrier" type="text"
                  [ngClass]="{ 'is-valid': (returnShippingform?.get('carrier').dirty  ) && !returnShippingform?.get('carrier')?.errors, 
                                                'is-invalid': (returnShippingform?.get('carrier').dirty  ) && returnShippingform?.get('carrier')?.errors }">
                <div class="invalid-feedback">
                  @if ( returnShippingform?.get('carrier')?.errors &&
                  returnShippingform?.get('carrier')?.errors['required']) {
                  <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="accountNumber"
                  class="control-label">{{'returnShippingInformation.account_number'|cxTranslate}}</label>
                <input formControlName="accountNumber" class="form-control" name="accountNumber" type="text"
                  [ngClass]="{ 'is-valid': (returnShippingform?.get('accountNumber').dirty  ) && !returnShippingform?.get('accountNumber')?.errors, 
                                                    'is-invalid': (returnShippingform?.get('accountNumber').dirty  ) && returnShippingform?.get('accountNumber')?.errors }">
                <div class="invalid-feedback">
                  @if ( returnShippingform?.get('accountNumber')?.errors &&
                  returnShippingform?.get('accountNumber')?.errors['required']) {
                  <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                  }
                </div>
              </div>
            </div> -->
            <!--   <div class="row margin-top-25">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="accountPostalCode"
                  class="control-label">{{'returnShippingInformation.account_postal_code'|cxTranslate}}</label>
                <input type="text" formControlName="accountPostalCode" class="form-control" name="accountPostalCode"
                  [ngClass]="{ 'is-valid': (returnShippingform?.get('accountPostalCode').dirty  ) && !returnShippingform?.get('accountPostalCode')?.errors, 
                                                    'is-invalid': (returnShippingform?.get('accountPostalCode').dirty  ) && returnShippingform?.get('accountPostalCode')?.errors }">
                <div class="invalid-feedback">
                  @if ( returnShippingform?.get('accountPostalCode')?.errors &&
                  returnShippingform?.get('accountPostalCode')?.errors['required']) {
                  <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="accountCountryCode"
                  class="control-label">{{'returnShippingInformation.account_country_code'|cxTranslate}}</label>
                <input type="text" formControlName="accountCountryCode" class="form-control" name="accountCountryCode"
                  [ngClass]="{ 'is-valid': (returnShippingform?.get('accountCountryCode').dirty  ) && !returnShippingform?.get('accountCountryCode')?.errors, 
                                                'is-invalid': (returnShippingform?.get('accountCountryCode').dirty  ) && returnShippingform?.get('accountCountryCode')?.errors }">
                <div class="invalid-feedback">
                  @if ( returnShippingform?.get('accountCountryCode')?.errors &&
                  returnShippingform?.get('accountCountryCode')?.errors['required']) {
                  <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                  }
                </div>
              </div>
            </div> -->
            <div class="row margin-top-25">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <re-captcha id="recaptcha" #captchaRef="reCaptcha" (resolved)="onCaptchaResolved($event)"
                  (expired)="onCaptchaExpired()" (error)="onCaptchaError()" name="recaptcha"
                  [class.is-invalid]="captchaTouched  &&!captchaResolved">
                </re-captcha>
                @if (captchaTouched && !captchaResolved) {
                <div class="invalid-feedback">
                  {{'common.general_required'|cxTranslate}}.
                </div>
                }
              </div>
              <div class="col-xs-12 col-sm-12">
                <label for="accountCountryCode"
                  class="control-label">{{'returnShippingInformation.e-signature'|cxTranslate}}</label>
                <p class="user-info">{{customerData?.contactName}}&nbsp;{{currentTime}}</p>
              </div>
            </div>
            <div class=" endsure-btnblock">
              <button class="btn-action btn-back mt-4" (click)="back()" type="button">
                <img src="/icons/link_left_white.svg" class="next-icon-right default-icon" alt="Back">
                {{ 'dataExtractionRquest.back' | cxTranslate }}</button>

              <button class="btn-action btn-next mt-4" [disabled]="!allowSubmit" type="button"
                (click)="next()">{{'common.text_account_supporttickets_createTicket_submit'|cxTranslate}}
                <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="Next">
              </button>

            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Popup for contactName -->
@if (popupReturnShippingInformation) {
<div class="popup-backdrop"></div>
}

@if (popupReturnShippingInformation) {
<div class="popup-modal">
  <div class="popup-header">
    <button class="close-btn" aria-label="close dialog" (click)="closeReturnShippingInformationpopup()">
      <img src="/icons/close-light-grey.svg" alt="" />
    </button>
  </div>
  <div class="popup-body">
    <span class="popup-title">{{'returnShippingInformation.return_shipping_type'|cxTranslate}}</span>
    <p class="mt-3">
      <b>{{'returnShippingInformation.domestic_shipping_label'|cxTranslate}}</b>
      <b><u>{{'returnShippingInformation.domestic_not_required'|cxTranslate}}</u></b>
      {{'returnShippingInformation.domestic_shipping_desc'|cxTranslate}}
    </p>
    <p class="mt-3">
      <b>{{'returnShippingInformation.international_shipping_label'|cxTranslate}}</b>
      <b><u>{{'returnShippingInformation.international_required'|cxTranslate}}</u></b>
      {{'returnShippingInformation.international_shipping_desc'|cxTranslate}}
    </p>
  </div>
</div>
}